import { iHolidayQuoteX } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { holidayQuotesXDefaultQueryConfig } from "./holiday-quotes-x-default-query";

export const {
  slice: HolidayQuotesXSlice,
  reducers: HolidayQuotesXSliceReducer,
  actions: {
    setEntityQueryResults: setHolidayQuotesXQueryResults,
    setEntity: setHolidayQuoteX,
    setEntities: setHolidayQuotesX,
    patchEntity: patchHolidayQuoteX,
    addNewEntity: addNewHolidayQuoteX,
    setEntityFetchingStatus: setHolidayQuoteXFetchingStatus,
    setEntitiesFetchingStatus: setHolidayQuotesXFetchingStatus,
    setEntityFailedStatus: setHolidayQuoteXFailedStatus,
    setEntityQueryError: setHolidayQuotesXQueryError,
    resetQuery: resetHolidayQuotesXQuery,
    setQueryList: setHolidayQuoteXQueryList,
  },
} = CreateEntitySlice<iHolidayQuoteX>({
  sliceName: "holidayQuotesX",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...holidayQuotesXDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
